<template>
  <h1>请联系设计师获取合同签署链接</h1>
</template>

<script>
export default {
  name: 'Page404'
}
</script>

<style lang="scss" scoped>
h1 {
  font-size: 40px;
  text-align: center;
  line-height: 800px;
}
</style>
